module.exports = __webpack_public_path__ + "static/img/top_bg1.1.4034e9c3.png";